import { Fragment, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styles from './index.scss';
import { getPropsToLabelColaboradores } from 'utils/HelpButtonUtils';
import HelpButtonEditEscola from 'components/HelpButton/HelpButtonEditEscola/HelpButtonEditEscola';
import { Container } from '@material-ui/core';
import SnackbarUtils from 'utils/SnackbarUtils';
import { isAuthorizedRequest } from 'utils/httpResponseHandlers';
import { getElementID } from 'utils/HTMLUtils';
import { Col } from 'components/Col';
import { CustomCard } from 'components/CustomCard';
import { NewAutoCompleteField } from 'components/NewAutoCompleteField';
import { Row } from 'components/Row';
import { CustomNumberField } from 'components/CustomNumberField';
import { UnauthorizedScreen } from 'components/UnauthorizedScreen';
import {
  changePeriodoEditingValuePanoramaFinancas,
  clearPeriodoEditingFinancas,
  loadPeriodoByIdFinancas,
  loadAnoByIdFinancas,
  postSavePeriodoFinancas,
  putSavePeriodoFinancas,
  setEnviarFormularioPeriodo
} from 'store/modules/EscolasActions';
import useValidationFields from '../../../../../hooks/useValidationFields';
import { useAtualizarPeriodoAtualDuplicacao } from '../../../../../hooks/usePeriodo';
import useProgramas from 'pages/Escola/Cadastro/etapas/ProgramasEducacionais/hooks/useProgramas';
import { TipoPrograma } from 'store/modules/EscolasTypes';

const rootClassName = styles.rootClassName;
const rootElementId = 'financas-escolar-edit';

const INITIAL_STATE = {
  authorizedRequest: true,
  sending: false,
  loading: false,
  colaboradoresChanged: false,
  ensFundIProfChanged: false,
  ensFundIAlunChanged: false,
  ensFundIIProfChanged: false,
  ensFundIIAlunChanged: false,
  especializadaProfChanged: false,
  especializadaAlunEspecializadoChanged: false,
  loadingPeriodos: true,
};

const FormDadosFinancas = ({ id, periodo, idPeriodo, onRefresh, formKey }) => {
  const [state, setState] = useState(INITIAL_STATE);
  const escolas = useSelector((escolasState) => escolasState.escolas);
  const languageValues = useSelector((languageState) => languageState.languages.languageValues);
  const auth = useSelector((authState) => authState.auth);
  const periodoKey = 'periodoEditingFinancas';
  const { retornaListaPeriodos, useTituloModal } = useProgramas();
  const { errors, formIsValid, processing } = useValidationFields(escolas, languageValues, periodoKey);
  const enviarFormulario = useSelector((stateReducer) => stateReducer.escolas.enviarFormularioPeriodo);
  const duplicacaoPeriodo = formKey === "duplicar"
  const dispatch = useDispatch();

  const tituloModal = useTituloModal(formKey, TipoPrograma.FinancasNaMochila);

  const loadPeriodo = () => {
    setState((prevState) => ({ ...prevState, loading: true }));
    dispatch(
      loadPeriodoByIdFinancas(
        idPeriodo,
        () => {
          setState((prevState) => ({
            ...prevState,
            loading: false,
            ensFundIProfChanged: true,
            ensFundIAlunChanged: true,
            ensFundIIProfChanged: true,
            ensFundIIAlunChanged: true,
            ensMedioProfChanged: true,
            ensMedioAlunChanged: true,
            especializadaProfChanged: true,
            especializadaAlunChanged: true,
          }));
          loadPeriodos();
        },
        (error) => {
          SnackbarUtils.enqueueSnackbar({
            message:
              error.response.statusText ||
              languageValues.errorLoadPeriodoEditing,
            options: {
              variant: 'error',
            },
          });
        }
      )
    );
  };

  const loadPeriodos = () => {
    dispatch(
      loadAnoByIdFinancas(
        id,
        () => {
          setState((prevState) => ({ ...prevState, loadingPeriodos: false }));
        },
        (error) => {
          SnackbarUtils.enqueueSnackbar({
            message:
              error.response.statusText ||
              languageValues.errorLoadPeriodosList,
            options: {
              variant: 'error',
            },
          });
        }
      )
    );
  };

  const editing = () => {
    return periodo && periodo.length > -1;
  };

  const mensagemEnvio = () => {
    switch (true) {
      case duplicacaoPeriodo:
        return languageValues.successDuplicarPeriodo;
      case editing():
        return languageValues.successSalvarPeriodo;
      default:
        return languageValues.successCadastrarPeriodo;
    }
  };

  const setValue = (event) => {
    const cuttedName = event.target.name
      .split('Prof')
      .join('')
      .split('Alun')
      .join('');
    let value;
    if (event.target.value === '') {
      value = '';
    } else {
      value = [
        'ensFundIAlun',
        'ensFundIProf',
        'ensFundIIProf',
        'ensFundIIAlun',
        'especializadaProf',
        'especializadaAlun',
        'colaboradores',
      ].indexOf(cuttedName) > -1
        ? Number(event.target.value)
        : event.target.value;
    }
    setState((prevState) => ({
      ...prevState,
      [event.target.name + 'Changed']: true,
    }));
    dispatch(changePeriodoEditingValuePanoramaFinancas(event.target.name, value));
  };

  const toSubmit = async () => {
    if (!formIsValid()) {
      return Promise.resolve();
    }

    const replaceEmptyWithZero = Object.entries(escolas.periodoEditingFinancas).reduce(
      (acc, [key, value]) => ({ ...acc, [key]: value === '' ? 0 : value }),
      {}
    );

    setState((prevState) => ({ ...prevState, sending: true }));

    const postValoresPeriodo = {
      idPeriodo: replaceEmptyWithZero.periodo || idPeriodo,
      colaboradores: replaceEmptyWithZero.colaboradores,
      idEscola: id,
      ensFundIProf: replaceEmptyWithZero.ensFundIProf,
      ensFundIAlun: replaceEmptyWithZero.ensFundIAlun,
      ensFundIIProf: replaceEmptyWithZero.ensFundIIProf,
      ensFundIIAlun: replaceEmptyWithZero.ensFundIIAlun,
      ensMedioProf: replaceEmptyWithZero.ensMedioProf,
      ensMedioAlun: replaceEmptyWithZero.ensMedioAlun,
      especializadaProf: replaceEmptyWithZero.especializadaProf,
      especializadaAlun: replaceEmptyWithZero.especializadaAlun,
    };

    const putValoresPeriodo = {
      idPeriodo: Number(periodo),
      colaboradores: replaceEmptyWithZero.colaboradores,
      ensFundIProf: replaceEmptyWithZero.ensFundIProf,
      ensFundIAlun: replaceEmptyWithZero.ensFundIAlun,
      ensFundIIProf: replaceEmptyWithZero.ensFundIIProf,
      ensFundIIAlun: replaceEmptyWithZero.ensFundIIAlun,
      ensMedioProf: replaceEmptyWithZero.ensMedioProf,
      ensMedioAlun: replaceEmptyWithZero.ensMedioAlun,
      especializadaProf: replaceEmptyWithZero.especializadaProf,
      especializadaAlun: replaceEmptyWithZero.especializadaAlun,
    };

    return new Promise((resolve, reject) => {
      const onSuccess = () => {
        SnackbarUtils.enqueueSnackbar({
          message: mensagemEnvio(),
          options: { variant: 'success' },
        });
        setState((prevState) => ({ ...prevState, sending: false }));
        retornaListaPeriodos(id, TipoPrograma.FinancasNaMochila, true);
        onRefresh()
        resolve(true);
      };

      const onError = (error) => {
        if (isAuthorizedRequest(error.response)) {
          SnackbarUtils.enqueueSnackbar({
            message:
              error.response.statusText ||
              (duplicacaoPeriodo
                ? languageValues.erroDuplicarPeriodo
                : editing()
                  ? languageValues.erroSalvarPeriodo
                  : languageValues.erroCadastrarPeriodo),
            options: { variant: 'error' },
          });
          setState((prevState) => ({ ...prevState, sending: false }));
        } else {
          setState((prevState) => ({
            ...prevState,
            sending: false,
            authorizedRequest: false,
          }));
        }
        retornaListaPeriodos(id, TipoPrograma.FinancasNaMochila, true);
        onRefresh()
        reject(error);
      };

      if (editing() && !duplicacaoPeriodo) {
        dispatch(putSavePeriodoFinancas(idPeriodo, putValoresPeriodo)(onSuccess, onError));
        retornaListaPeriodos(id, TipoPrograma.FinancasNaMochila, true);
        onRefresh()
      } else {
        dispatch(postSavePeriodoFinancas(postValoresPeriodo, onSuccess, onError));
        retornaListaPeriodos(id, TipoPrograma.FinancasNaMochila, true);
        onRefresh()
      }
    });
  };

  const getValueTypes = () => {
    return [
      'ensFundI',
      'ensFundII',
      'especializada',
    ];
  };

  const getCompletedLabels = (isProf) => {
    return [
      languageValues[
      'ensinoFundamentalI' + (isProf ? 'Prof' : 'Alun') + 'LabelFinancas'
      ],
      languageValues[
      'ensinoFundamentalII' + (isProf ? 'Prof' : 'Alun') + 'LabelFinancas'
      ],
      languageValues['escolaEspecializada' + (isProf ? 'Prof' : 'Alun') + 'LabelFinancas'],
    ];
  };

  const getPeriodos = () => {
    return escolas.periodoEditingFinancas.periodosList.map((p) => ({
      value: formKey === "editar" ? p.nomPeriodo : p.id,
      label: p.nomPeriodo.split('-').join('/'),
    }));
  };

  useAtualizarPeriodoAtualDuplicacao(duplicacaoPeriodo, 'financas');

  useEffect(() => {
    if (editing()) {
      if (auth.userPermissions.escolas.dadosDaEscola.edit) {
        loadPeriodo();
      } else {
        setState((prevState) => ({ ...prevState, authorizedRequest: false }));
      }
    } else {
      if (auth.userPermissions.escolas.dadosDaEscola.register) {
        loadPeriodos();
      } else {
        setState((prevState) => ({ ...prevState, authorizedRequest: false }));
      }
    }

    return () => {
      dispatch(clearPeriodoEditingFinancas());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, id, periodo, auth, languageValues]);

  useEffect(() => {
    if (enviarFormulario) {
      toSubmit();
      dispatch(setEnviarFormularioPeriodo(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enviarFormulario, dispatch]);

  return state.authorizedRequest ? (
    <Container
      style={{
        marginTop: 0,
        padding: 0
      }}>
      <CustomCard
        CardPropTypes={{
          className:
            rootClassName + '-card'
        }}
        CardHeaderPropTypes={{
          title: (
            <div className="custom-title-wrapper">
              <span className="custom-title-text">
                {`${tituloModal} de dados do ano do programa Finanças na Mochila`}
              </span>
              <span className="custom-title-sub">
                Informe os dados anuais do programa
              </span>
            </div>
          )
        }}
        titleHint={languageValues.dadosDaEscolaEditHint}
        sending={state.sending || state.loading}
      >
        <form
          onSubmit={(event) => {
            event.preventDefault();
            toSubmit();
          }}
        >
          <Row>
            <Col cols={[12, 6, 6, 6, 6]}>
              <NewAutoCompleteField
                id={getElementID(rootElementId, 'periodo')}
                label={languageValues.ano}
                placeholder={
                  escolas.periodoEditingFinancas.loadingPeriodosList
                    ? languageValues.loadingPeriodos
                    : 'Selecionar o Ano'
                }
                options={getPeriodos()}
                value={escolas.periodoEditingFinancas.periodo || ''}
                onChange={(value) => {
                  const currValue = value && value.value > '' ? value.value : '';
                  setValue({
                    target: {
                      name: 'periodo',
                      value: currValue,
                    },
                  });
                }}
                loading={escolas.periodoEditingFinancas.loadingPeriodosList}
                loadingMessage={languageValues.loadingPeriodos}
                disabled={(editing() || duplicacaoPeriodo || processing() || state.loadingPeriodos)}
              />
            </Col>

            <Col cols={[12, 6, 6, 6, 6]}>
              <CustomNumberField
                id={getElementID(rootElementId, 'colaboradores')}
                disabled={processing()}
                onlyInteger={true}
                onlyPositive={true}
                label={languageValues.colaboradoresFinancas}
                name={'colaboradores'}
                onBlur={(event) => {
                  if (event.target.value === '') {
                    setValue({ target: { name: event.target.name, value: 0 } });
                  }
                }}
                value={escolas.periodoEditingFinancas.colaboradores}
                onChange={setValue}
              />
            </Col>
          </Row>
          {getValueTypes().map((type, index) => {
            const isEscolaEspecializadaProfLabel =
              type === 'especializada' && 'isProf';

            return (
              <Row key={index}>
                <Col cols={[12, 6, 6, 6, 6]}>
                  <CustomNumberField
                    id={getElementID(rootElementId, type + '-professor')}
                    disabled={processing()}
                    onlyInteger={true}
                    onlyPositive={true}
                    label={
                      <Fragment>
                        {getCompletedLabels(true)[index]}
                        {isEscolaEspecializadaProfLabel && (
                          <HelpButtonEditEscola
                            text={languageValues.hintEducacaoInfantilProfLabel}
                            {...getPropsToLabelColaboradores()}
                          />
                        )}
                      </Fragment>
                    }
                    name={type + 'Prof'}
                    value={escolas.periodoEditingFinancas[type + 'Prof']}
                    onChange={setValue}
                    onBlur={(event) => {
                      if (event.target.value === '') {
                        setValue({ target: { name: event.target.name, value: 0 } });
                      }
                    }}
                    error={errors[type + 'Prof']}
                  />
                  {errors[type + 'Prof'] && (
                    <div className="error-message">
                      {errors[type + 'Prof']}
                    </div>
                  )}
                </Col>
                <Col cols={[12, 6, 6, 6, 6]}>
                  <CustomNumberField
                    id={getElementID(rootElementId, type + '-aluno')}
                    disabled={processing()}
                    onlyInteger={true}
                    onlyPositive={true}
                    label={getCompletedLabels()[index]}
                    name={type + 'Alun'}
                    value={escolas.periodoEditingFinancas[type + 'Alun']}
                    onChange={setValue}
                    onBlur={(event) => {
                      if (event.target.value === '') {
                        setValue({ target: { name: event.target.name, value: 0 } });
                      }
                    }}
                    error={errors[type + 'Alun']}
                  />
                  {errors[type + 'Alun'] && (
                    <div className="error-message">
                      {errors[type + 'Alun']}
                    </div>
                  )}
                </Col>
              </Row>
            );
          })}
        </form>
      </CustomCard>
    </Container>
  ) : (
    <UnauthorizedScreen />
  );
}

export default FormDadosFinancas


